// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"8c4ba017","515":"c6864c98","756":"985d5f4f","837":"7445e107","892":"56fdf454"}[chunkId] + ".chunk.js";
};